/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { createSelector } from '@reduxjs/toolkit';

import { IRootReducer } from '@reducers/rootReducer';

import { constructorSlice } from './slice';

export const reportsConstrucotrSliceSelector = (state: IRootReducer) => state[constructorSlice.name];

export const reportsConstructorSelectedItemSelector = createSelector(
    reportsConstrucotrSliceSelector,
    ({ selectedItem }) => selectedItem,
);

export const reportsConstructorCurrentRowItemSelector = createSelector(
    reportsConstrucotrSliceSelector,
    ({ currentRowItem }) => currentRowItem,
);

export const reportsConstructorTemplatesSelector = createSelector(
    reportsConstrucotrSliceSelector,
    ({ templatesData }) => templatesData.elements,
);

export const reportsConstructorTemplatesCountSelector = createSelector(
    reportsConstrucotrSliceSelector,
    ({ templatesData }) => templatesData.count,
);

export const reportsConstructorTemplatesPageSelector = createSelector(
    reportsConstrucotrSliceSelector,
    ({ templatesData }) => templatesData.page,
);
